import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-6 text-center" }, "Войти в кабинет", -1)

import { useAccountStore } from '@/stores/account';
import { reactive, ref, watch } from 'vue';
import SkolkovoHeader from '@/components/SkolkovoHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props) {

const login = ref("")
const password = ref("")
const accountStore = useAccountStore()

const errors = reactive<{ [key: string]: string }>({})
const pending = ref(false)

watch(login, () => delete errors['login'])
watch(password, () => delete errors['password'])

const submit = async () => {
  pending.value = true
  try {
    await accountStore.login({ login: login.value, password: password.value })
  } catch(e: any) {
    if (e.error) {
      Object.assign(errors, e.error)
    }
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SkolkovoHeader),
    _createVNode(_component_v_layout, { class: "align-center justify-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "auth-card",
          elevation: "4"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_v_form, {
              onSubmit: _withModifiers(submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: login.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login).value = $event)),
                  "error-messages": errors['login'],
                  label: "Login",
                  variant: "outlined"
                }, null, 8, ["modelValue", "error-messages"]),
                _createVNode(_component_v_text_field, {
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  "error-messages": errors['password'],
                  label: "Password",
                  variant: "outlined",
                  type: "password"
                }, null, 8, ["modelValue", "error-messages"]),
                _createVNode(_component_v_btn, {
                  width: "100%",
                  height: "44",
                  color: "primary",
                  type: "submit",
                  disabled: pending.value,
                  "append-icon": "mdi-login-variant"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Войти")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})